/* tslint:disable */

declare var Object: any;
export interface CounterInterface {
  prefix?: string;
  sequence: number;
  suffix?: string;
  id?: any;
}

export class Counter implements CounterInterface {
  prefix: string;
  sequence: number;
  suffix: string;
  id: any;
  constructor(data?: CounterInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Counter`.
   */
  public static getModelName() {
    return "Counter";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Counter for dynamic purposes.
  **/
  public static factory(data: CounterInterface): Counter{
    return new Counter(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Counter',
      plural: 'counters',
      properties: {
        prefix: {
          name: 'prefix',
          type: 'string',
          default: ''
        },
        sequence: {
          name: 'sequence',
          type: 'number',
          default: 10000001
        },
        suffix: {
          name: 'suffix',
          type: 'string',
          default: ''
        },
        id: {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Counter.ts